<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_table_of_contents_1"><span style=" font-weight: bold; font-size: 1.17em;">Cullen s’avéra être un bon joueur de Cribbage, avançant rapidement ses pions sur la planche en peu de temps. Matt était plutôt content de la façon dont les siens avançaient aussi alors qu’il grignotait des chips au fromage, tendant le sac à l’autre homme de temps en temps.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Ils ne parlaient pas beaucoup, qu’auraient-ils eu à se dire ? Cela n’avait pas d’importance. Il avait des décisions à prendre et Cullen aussi. Il voulait le faire avec l’esprit clair et sans être influencé par un nouveau propriétaire désespéré qui ne connaissait rien à l’embauche d’un nouveau directeur.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Deux sur trois, s’exclama Cullen en riant lorsque Matt gagna la partie. C’est bien.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Merci, répondit celui-ci, se surprenant en offrant de jouer le meilleur de trois parties sur cinq.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Oh, oui. J’ai besoin d’une chance de me rattraper, répliqua Cullen en riant, un son bas et sexy.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Matt s’occupa de récupérer et de mélanger les cartes, laissant le bavardage dégager son cerveau pendant que l’autre homme déplaçait les pions sur le départ. La simple joie de jouer tard dans la soirée lui avait manqué depuis que Ben était décédé.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Cullen était une bonne compagnie.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Il détestait l’admettre, mais c’était vrai, bon sang.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?51f0cfd8